// This file should contain plain stuff and not import anything (except for maybe types)
import {DefaultExtent} from "../../interfaces/defaultExtentInterface";
import { IYearFilter } from "../../interfaces/YearFilternterface";
import { IAppLayer } from '../../interfaces/AppLayerInterface'
import {runtimeConfig} from "../../runtimeConfig";

export const EPSG = 2056;

// use coords in the same spatial ref as defined in globalSpatialReference
export const infra3dStartPosition =
    runtimeConfig.ENVIRONMENT === "Showcase"
        ? [2771517.7, 1171777.0]
        : [2770869.9, 1172325.3];

export const defaultExtent :DefaultExtent = {
    xmin: 2675720,
    ymin: 1246980,
    xmax: 2681085,
    ymax: 1251365,
    spatialReference: {
        wkid: EPSG,
    },
};
export const yearFilterConfig:IYearFilter[] = [
    {
        id: 0,
        label: "Loading Campaigns",
        selected: true,
        url: "",
        infra3dCampaignId: 0,
        infra3dCampaignName: "",
        infra3dLayerName: "",
        mapTopics: []
    },
];

export const cimMarkerSymbol = {
    type: "CIMPointSymbol" as const,
    symbolLayers: [
        {
            type: "CIMVectorMarker" as const,
            enable: true,
            anchorPoint: {
                x: 0,
                y: 0,
            },
            anchorPointUnits: "Absolute" as const,
            dominantSizeAxis3D: "Y",
            size: 10,
            billboardMode3D: "FaceNearPlane",
            frame: {
                xmin: 0,
                ymin: 0,
                xmax: 17,
                ymax: 17,
            },
            markerGraphics: [
                {
                    type: "CIMMarkerGraphic" as const,
                    geometry: {
                        rings: [
                            [
                                [8.5, 0],
                                [7.02, 0.13],
                                [5.59, 0.51],
                                [4.25, 1.14],
                                [3.04, 1.99],
                                [1.99, 3.04],
                                [1.14, 4.25],
                                [0.51, 5.59],
                                [0.13, 7.02],
                                [0, 8.5],
                                [0.13, 9.98],
                                [0.51, 11.41],
                                [1.14, 12.75],
                                [1.99, 13.96],
                                [3.04, 15.01],
                                [4.25, 15.86],
                                [5.59, 16.49],
                                [7.02, 16.87],
                                [8.5, 17],
                                [9.98, 16.87],
                                [11.41, 16.49],
                                [12.75, 15.86],
                                [13.96, 15.01],
                                [15.01, 13.96],
                                [15.86, 12.75],
                                [16.49, 11.41],
                                [16.87, 9.98],
                                [17, 8.5],
                                [16.87, 7.02],
                                [16.49, 5.59],
                                [15.86, 4.25],
                                [15.01, 3.04],
                                [13.96, 1.99],
                                [12.75, 1.14],
                                [11.41, 0.51],
                                [9.98, 0.13],
                                [8.5, 0],
                            ],
                        ],
                    },
                    symbol: {
                        type: "CIMPolygonSymbol" as const,
                        symbolLayers: [
                            {
                                type: "CIMSolidStroke" as const,
                                enable: true,
                                capStyle: "Round" as const,
                                joinStyle: "Round" as const,
                                lineStyle3D: "Strip",
                                miterLimit: 10,
                                width: 2,
                                color: [255, 255, 255, 255]as [number, number, number, number],
                            },
                            {
                                type: "CIMSolidFill" as const,
                                enable: true,
                                color: [255, 0, 0, 255]as [number, number, number, number],
                            },
                        ],
                    },
                },
            ],
            scaleSymbolsProportionally: true,
            respectFrame: true,
            rotateClockwise: true,
            rotation: 20,
        },
        {
            type: "CIMVectorMarker" as const,
            enable: true,
            anchorPointUnits: "Absolute" as const,
            dominantSizeAxis3D: "Y",
            size: 10,
            billboardMode3D: "FaceNearPlane",
            frame: {
                xmin: 0,
                ymin: 0,
                xmax: 17,
                ymax: 17,
            },
            markerGraphics: [
                {
                    type: "CIMMarkerGraphic" as const,
                    geometry: {
                        rings: [
                            [
                                [0, 0.65],
                                [8.5, 16.35],
                                [17, 0.65],
                                [0, 0.65],
                            ],
                        ],
                    },
                    symbol: {
                        type: "CIMPolygonSymbol" as const,
                        symbolLayers: [
                            {
                                type: "CIMSolidStroke" as const,
                                enable: true,
                                capStyle: "Round" as const,
                                joinStyle: "Round" as const,
                                lineStyle3D: "Strip",
                                miterLimit: 10,
                                width: 1,
                                color: [255, 255, 255, 255]as [number, number, number, number],
                            },
                            {
                                type: "CIMSolidFill" as const,
                                enable: true,
                                color: [255, 0, 0, 255]as [number, number, number, number],
                            },
                        ],
                    },
                },
            ],
            scaleSymbolsProportionally: true,
            respectFrame: true,
            offsetX: 0,
            offsetY: 0,
            anchorPoint: {
                x: 0,
                y: -8,
            },
            rotateClockwise: true,
            rotation: 0,
        },
    ],
};

export enum ChartType {
    BarChartLine,
    AreaChartTrend,
    LineChartChanges,
    PieChart,
    BarChartYear,
    SingleBarChartCost
}
